import React from 'react'
import PropTypes from 'prop-types'
import get from 'lodash.get'
import _ from 'lodash'
import {
  Map,
  TileLayer,
  Polygon,
  ZoomControl
} from 'react-leaflet'
import WMTSTileLayer from 'react-leaflet-wmts'
import * as turf from '@turf/turf'
import gql from 'graphql-tag'

import GraphqlQuery from '../../molecules/GraphqlQuery'

import PopupContainer from './Popup';

import './Map.css'
import 'leaflet/dist/leaflet.css'

const GET_CITY_GEOJSON_BY_ID = gql`
  query CityGeojsonById($id: Int!) {
    cityGeojsonById(id: $id) {
      geojson
    }
  }
`;

const config = {
  lat: -15,
  lng: -52,
  zoom: 4,
  minZoom: 4,
  maxBounds: [[85, -180], [-85, 180]]
}

const renderLayers = layers => {
  const nLayers = Array.from(layers.layers)

  return nLayers
    .reverse()
    .filter(item => {
      const isVisible = get(item, 'config.visibility', true)

      return isVisible
    })
    .map((item, key) => {
      return (
        <WMTSTileLayer
          opacity={get(item, 'config.opacity', 100) / 100}
          key={key}
          transparent
          url={"https://mapas.imaflora.org:8443/geoserver/gwc/service/wmts"}
          layer={item.id}
          style="normal"
          tilematrixSet="EPSG:900913"
          format="image/png"
        />
      );
    })
}

class MapComponent extends React.Component {
  constructor() {
    super();

    this.state = {
      currentActiveCityId: null
    };
  }

  componentDidMount () {
    this.map = this.refs.map.leafletElement;
  }

  parseCoordinates(coordinates) {
    const coordinatesClone =  _.cloneDeep(coordinates);
    const baseItem = _.first(coordinatesClone);

    return _.map(baseItem, (list) => {
      return _.map(list, (item) => {
        return item.reverse()
      });
    });
  }

  render() {
    const {
      onClick,
      layers,
      popupCoordinates,
      selectedLayerId,
      onPopupClose
    } = this.props;

    return (
      <Map
        animate
        ref="map"
        onClick={onClick}
        center={[config.lat, config.lng]}
        zoom={config.zoom}
        minZoom={config.minZoom}
        maxBounds={config.maxBounds}
        zoomControl={false}
      >
        <TileLayer
          url="https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_nolabels/{z}/{x}/{y}{r}.png"
          attribution='&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="http://cartodb.com/attributions">CartoDB</a>'
        />
        { renderLayers(layers) }
        <GraphqlQuery
          query={ GET_CITY_GEOJSON_BY_ID }
          variables={ { id: this.props.activeCityId || 1 } }
        >
          {({ cityGeojsonById: { geojson } }) => {
            const cityFeature = _.first(geojson.features);

            if (_.isUndefined(cityFeature)) { return null; }

            const multiPolygonPositions = this.parseCoordinates(cityFeature.geometry.coordinates);
            const polygon = turf.polygon(multiPolygonPositions);
            const bbox = turf.bbox(polygon);
            const bounds = [[bbox[0], bbox[1]], [bbox[2], bbox[3]]];

            if ((_.isNull(this.state.currentActiveCityId) && this.props.activeCityId) ||
                (this.state.currentActiveCityId !== this.props.activeCityId)
            ) {
              this.setState({ currentActiveCityId: this.props.activeCityId });
              this.map.flyToBounds(bounds, { padding: [50, 50] });
            }

            return (
              <Polygon color="white" fill={ false } positions={ multiPolygonPositions } />
            );
          }}
        </GraphqlQuery>
        <PopupContainer
          coordinates={ popupCoordinates }
          layerId={ selectedLayerId }
          layersData={ layers.data }
          onClose={ onPopupClose }
        />
        <ZoomControl position="bottomright" />
      </Map>
    );
  }
}

MapComponent.propTypes = {
  onClick: PropTypes.func.isRequired,
  layers: PropTypes.array.isRequired
}

export default MapComponent



// WEBPACK FOOTER //
// ./src/components/molecules/Map/Map.js